import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M44.67 10.25C37.89 1.54 28.14 1.35001 26.06 1.45001C23.98 1.36001 13.91 1.3 7.44997 10.25C-0.670033 21.5 2.05997 45.83 2.05997 45.83C2.05997 45.83 5.00997 38.38 6.10997 22.27C6.43997 17.43 9.07997 14.46 11.91 13.46C15.94 12.05 21.16 14.01 26.07 14.01C30.59 14.01 35.53 12.38 39.46 13.46C42.8 14.37 45.39 17.54 45.89 21.68C47.88 38.01 50.28 46.16 50.28 46.16C50.28 46.16 53.34 21.39 44.67 10.25Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M30.6699 10.5199C29.7399 10.5199 28.8899 10.9699 28.3399 11.6199C28.0599 11.9499 27.8599 12.3199 27.6899 12.7199C27.5299 13.1199 27.4299 13.5399 27.3499 13.9599L26.3799 13.6999C26.5599 13.2399 26.7499 12.7899 27.0199 12.3699C27.2899 11.9599 27.6099 11.5699 27.9899 11.2599C28.7599 10.6399 29.7599 10.3499 30.6699 10.5199Z"
        fill={outline}
      />
      <path
        d="M28.0201 8.62C27.5801 8.79 27.23 9.11998 26.97 9.47998C26.7 9.84998 26.5101 10.26 26.3801 10.69C26.1001 11.55 26.04 12.46 26.04 13.36L25.04 13.28C25.2 12.32 25.45 11.36 25.92 10.49C26.14 10.06 26.43 9.65 26.78 9.31C27.13 8.99 27.5601 8.71 28.0201 8.62Z"
        fill={outline}
      />
      <path
        d="M21.9099 11.1C22.4099 11.24 22.8999 11.48 23.3199 11.86C23.7499 12.23 24.0699 12.76 24.2199 13.36L23.2299 13.46C23.2699 13.04 23.1799 12.59 22.9399 12.18C22.7099 11.76 22.3499 11.38 21.9099 11.1Z"
        fill={outline}
      />
      <path
        d="M30.91 11.27C30.35 11.47 29.85 11.8101 29.51 12.2401C29.16 12.6601 29.01 13.17 29.01 13.67L28.02 13.5101C28.22 12.8401 28.63 12.2401 29.17 11.8801C29.71 11.4901 30.32 11.3 30.91 11.27Z"
        fill={outline}
      />
    </g>
  )
}
